<template>
  <q-icon
    :name="imageUrl"
    :size="size"
  />
</template>

<script>
export default {
  props: {
    driver: {
      type: String,
      required: true
    },
    light: {
      type: Boolean,
      default: false
    },
    size: {
      type: [String, Number]
    }
  },
  data () {
    return {
      drivers: {
        xero: {
          default: 'xero.png',
          light: 'xero-white.png'
        },
        quickbooks: {
          default: 'quickbooks.png',
          light: 'quickbooks-white.png'
        },
        myobaccountrightlive: {
          default: 'myob.png',
          light: 'myob-light.png'
        },
        stripe: {
          default: 'stripe.png',
          light: 'stripe-light.png'
        },
        square: {
          default: 'square.png',
          light: 'square-white.png'
        },
        rfccalendar: {
          icon: 'mdi-calendar-end'
        }
      }
    }
  },
  computed: {
    imageUrl () {
      if (this.drivers[this.driver]) {
        const icons = this.drivers[this.driver]
        if (icons.icon) {
          return icons.icon
        }
        if (this.light) {
          return `img:providers/${icons.light || icons.default}`
        }
        return `img:providers/${icons.default}`
      }
      return 'mdi-help'
    }
  }
}
</script>
